import { graphqlRequest } from '../graphql/client';
import {
  CREATE_PRODUCT_MUTATION,
  DELETE_PRODUCT_MUTATION,
  MANAGE_PRODUCTS_QUERY,
  UPDATE_PRODUCT_MUTATION,
} from '../graphql/documents';
import { replaceCatalog } from '../data/repository';
import type { ProductRecord } from '../data/types';

export interface ManagedProduct extends ProductRecord {
  id: string;
  name: string;
  categoryId?: number | null;
  categoryName?: string | null;
  isActive: boolean;
  catalogVersion: number;
  createdAt: string;
  updatedAt: string;
}

interface ManageProductsResponse {
  manageProducts: ManagedProduct[];
}

interface CreateProductResponse {
  createProduct: ManagedProduct;
}

interface UpdateProductResponse {
  updateProduct: ManagedProduct;
}

interface DeleteProductResponse {
  deleteProduct: ManagedProduct;
}

async function refreshCatalogCache(): Promise<ManagedProduct[]> {
  const data = await graphqlRequest<ManageProductsResponse>(MANAGE_PRODUCTS_QUERY);
  await replaceCatalog(data.manageProducts);
  return data.manageProducts;
}

export async function fetchProducts(): Promise<ManagedProduct[]> {
  return refreshCatalogCache();
}

export async function createProduct(input: {
  id: string;
  name: string;
  price?: number | null;
  categoryId?: number | null;
  isActive: boolean;
}): Promise<ManagedProduct> {
  const data = await graphqlRequest<CreateProductResponse>(CREATE_PRODUCT_MUTATION, { input });
  await refreshCatalogCache();
  return data.createProduct;
}

export async function updateProduct(input: {
  currentId: string;
  id: string;
  name: string;
  price?: number | null;
  categoryId?: number | null;
  isActive: boolean;
}): Promise<ManagedProduct> {
  const data = await graphqlRequest<UpdateProductResponse>(UPDATE_PRODUCT_MUTATION, { input });
  await refreshCatalogCache();
  return data.updateProduct;
}

export async function deleteProduct(id: string): Promise<ManagedProduct> {
  const data = await graphqlRequest<DeleteProductResponse>(DELETE_PRODUCT_MUTATION, { id });
  await refreshCatalogCache();
  return data.deleteProduct;
}
